module.exports = __webpack_public_path__ + "img/blog-66.52f5cf03.jpg";